import { render, staticRenderFns } from "./ErrorWorkbook.vue?vue&type=template&id=2ba6f245&scoped=true"
import script from "./ErrorWorkbook.vue?vue&type=script&lang=js"
export * from "./ErrorWorkbook.vue?vue&type=script&lang=js"
import style0 from "./ErrorWorkbook.vue?vue&type=style&index=0&id=2ba6f245&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6f245",
  null
  
)

export default component.exports